export default __webpack_public_path__ + "static/media/work_web-lg@1x.74e8d2fc.webp";